/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_Is_ApprovedInputs */

const vi_tea_package_is_approved = /** @type {(inputs: Tea_Package_Is_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phê duyệt`)
};

/**

* @param {Tea_Package_Is_ApprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_is_approved = /** @type {((inputs?: Tea_Package_Is_ApprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_Is_ApprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_is_approved(inputs)
});